/** @file Inspector body for one entity: header, optional intro, then one generated CommandForm per command. */
import { useMemo, type ReactNode } from 'react';
import { CommandForm } from '../../forms/CommandForm';
import { submitCalls } from '../../forms/submitCalls';
import { EntityHeader } from './EntityHeader';
import { ENTITY_FORMS } from './entityForms.data';
import { entityPrefill } from './entityPrefill';
import type { EntityViewProps } from './formKindOf';

/** One generated form; prefill and hidden keys are memoized so typed edits survive re-renders. */
function GeneratedForm({ doc, command, id, t }: Omit<EntityViewProps, 'kind'> & { command: string }) {
  const prefill = useMemo(() => entityPrefill(command, doc, id), [command, doc, id]);
  const hidden = useMemo(() => (prefill.identity === null ? [] : [prefill.identity]), [prefill]);
  return <CommandForm command={command} doc={doc} prefill={prefill.values} hidden={hidden} t={t} onSubmit={(call) => submitCalls([call])} />;
}

/** `forms` overrides the kind's list (MeshForm hides skinned-only commands); `intro` sits under the header. */
export function EntityForms({ doc, kind, id, t, forms, intro }: EntityViewProps & { forms?: readonly string[]; intro?: ReactNode }) {
  const list = forms ?? ENTITY_FORMS[kind].forms;
  return (
    <div className="p2-inspector-entity">
      <EntityHeader doc={doc} kind={kind} id={id} t={t} />
      {intro}
      {list.map((command) => <GeneratedForm key={`${command}:${id}`} doc={doc} command={command} id={id} t={t} />)}
    </div>
  );
}
